import { useContext } from "react";
import LocationExtraDataContext from "../../contexts/LocationExtraData/LocationExtraDataContext";

const useLocationExtraData = () => useContext(LocationExtraDataContext);

export default useLocationExtraData;